var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { PureComponent } from "react";
import { debouncePromise } from "../../util/debounce";
import AvisoAlert from "../shared/alert";
import AvisoDiv from "../shared/div";
import AdvisorService from "../../services/AdvisorService";
import DeprecatedSelect from "../../src/View/UI/DeprecatedSelect/DeprecatedSelect";
import FAIcon from "../../src/View/UI/FAIcon/FAIcon";
import { getXSRF } from "../../src/Services/Shared/FetchService";
class ShareModal extends PureComponent {
    constructor(props) {
        super(props);
        this.onPersonSelected = this.onPersonSelected.bind(this);
        this.share = this.share.bind(this);
        this.onCommentChange = this.onCommentChange.bind(this);
        this.state = {
            shareWith: null,
            errorMessage: "",
            comment: "",
        };
    }
    searchUsers(input) {
        return AdvisorService.searchUsingFilter(input, 20)
            .then((peopleResponse) => ({ options: peopleResponse.data }))
            .catch(() => ({ options: [] }));
    }
    onPersonSelected(value, event) {
        this.setState({ shareWith: value });
    }
    onCommentChange(event) {
        this.setState({ comment: event.target.value });
    }
    share() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.props.resource) {
                return;
            }
            if (!this.state.shareWith) {
                this.setState({
                    errorMessage: "Please select a person",
                });
            }
            const response = yield fetch(
            // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
            `/aviso/resourceGuide/share?resourceId=${this.props.resource.id}&affiliationId=${this.state.shareWith.affiliationId}`, {
                method: "POST",
                credentials: "include",
                body: JSON.stringify({ comment: this.state.comment }),
                headers: {
                    "Content-Type": "application/json",
                    "X-XSRF-TOKEN": getXSRF(),
                },
            });
            const result = yield response.json();
            if (result.success) {
                if (this.props.onSuccess) {
                    this.props.onSuccess();
                }
                this.setState({ shareWith: null, comment: "", errorMessage: "" });
                $(`#${this.props.id}`).modal("hide");
            }
            else {
                this.setState({
                    errorMessage: "There was an error sharing this resource. Please reload the page and try again.",
                });
            }
            console.log(response.url, result);
        });
    }
    renderPerson(person) {
        if (person.smallPhotoUrl) {
            return (_jsxs("span", { className: "p-1", children: [_jsx("img", { alt: person.fullName, className: "rounded-circle av-profile-image", src: person.smallPhotoUrl }), "\u00A0\u00A0", person.fullName, " ", _jsxs("small", { children: ["(", person.studentId, ")"] })] }));
        }
        return (_jsxs("span", { className: "p-1 d-flex align-items-center", children: [_jsxs("div", { className: "av-profile-image rounded-circle m-1", style: { backgroundColor: person.initialsBackgroundColorHex }, children: [person.firstName[0], person.lastName[0]] }), "\u00A0\u00A0", person.fullName, _jsxs("small", { children: ["(", person.studentId, ")"] })] }));
    }
    render() {
        return (_jsx("div", { className: "modal fade", id: this.props.id, children: _jsx("div", { className: "modal-dialog modal-lg", role: "document", children: _jsxs("div", { className: "modal-content", children: [_jsxs("div", { className: "modal-header", children: [_jsxs("h2", { className: "modal-title h5", children: ["Share ", this.props.resource.name] }), _jsx("button", { className: "close", title: "Close Modal", "data-dismiss": "modal", type: "button", children: _jsx(FAIcon, { icon: "times" }) })] }), _jsxs("div", { className: "modal-body", children: [_jsx(AvisoAlert, { message: this.state.errorMessage, show: !!this.state.errorMessage, type: "danger" }), _jsxs("div", { className: "form-group required", children: [_jsx("label", { htmlFor: "categoryName", children: "Person" }), _jsx(DeprecatedSelect.Async, { "aria-label": "Person", labelKey: "fullName", loadOptions: debouncePromise(this.searchUsers, 300), name: "form-field-name", onChange: this.onPersonSelected, value: this.state.shareWith, valueKey: "affiliationId" })] }), _jsx(AvisoDiv, { show: !!this.state.shareWith, children: _jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: "resource-share-modal-comment", children: "Comment" }), _jsx("textarea", { id: "resource-share-modal-comment", className: "form-control", onChange: this.onCommentChange, rows: 3, value: this.state.comment })] }) })] }), _jsxs("div", { className: "modal-footer", children: [_jsxs("button", { className: "btn btn-primary", onClick: this.share, type: "button", children: [_jsx("i", { "aria-hidden": "true", className: "fa fa-share-alt" }), _jsx("span", { className: "pl-1", children: "Share" })] }), _jsxs("button", { className: "btn btn-outline-secondary", "data-dismiss": "modal", type: "button", children: [_jsx("i", { "aria-hidden": "true", className: "fa fa-times mr-1" }), "Close"] })] })] }) }) }));
    }
}
export default ShareModal;
